import Vue, { VNode } from 'vue'
import { Component, Emit, Provide, Ref } from 'vue-property-decorator'

import $style from './index.module.scss'
import { Dropdown, DropdownItem, DropdownMenu, Input, Button } from 'element-ui'
import { namespace } from 'vuex-class'
import cookies from 'js-cookie'
import configs from '@/config'
import { UserInfoResDTO } from '@/services/permission'

const AppModule = namespace('app')
const webSiteLogo = 'https://va-papers.oss-accelerate.aliyuncs.com/oss-platform/6fe9/2164/5a38/a6f99e61-83a5-4612-9ef6-b9ead0a4bb3e'
@Component({
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Input.name]: Input,
    [Button.name]: Button
  }
})
export default class extends Vue {
  @AppModule.Getter('userInfo') userInfo!: UserInfoResDTO
  @Ref() refSearch!: Input

  @Provide() private kw = ''

  @Emit('search')
  private doSearch(kw: string): string {
    return kw
  }

  mounted(): void {
    // const input = this.refSearch.$el.getElementsByTagName('input')[0]

    // // eslint-disable-next-line @typescript-eslint/no-this-alias
    // const that = this
    // input.onkeyup = function(e) {
    //   console.log(e.key, '-----')
    //   if (e.key === 'Enter' || !that.kw) {
    //     that.doSearch()
    //   }
    // }
  }

  private searchBoxChanged(kw: string): void {
    this.doSearch(kw)
  }

  private command(command: string): void {
    switch (command) {
      case 'logout':
        // this.$api.Auth.logout().then(() => {
        //   this.$router.replace('/login')
        // })
        break
    }
  }

  private refreshPage(): void {
    window.location.reload()
  }

  private logout(): void {
    cookies.remove(configs.keySSOToken)
    location.replace('/login')
  }

  renderRight(): VNode | null {
    const { realName } = this.userInfo || {}
    return (
      <div class="header-right">
        {/* <div class="icon-item">
          <i class='el-icon-search'></i>
        </div> */}
        <div class="icon-item">
          <i class='el-icon-bell'></i>
        </div>
        <div class="avatar">
          {/* <img src={avatar} alt="" /> */}
          <span>{ (realName || '').slice(0, 1) }</span>
          <div class="user-name">{ realName }</div>
          {/* <div class="btn-logout" onClick={ this.logout }>退出</div> */}
        </div>
      </div>
    )
  }

  render(): VNode {
    return <div class={$style.component_header}>
      <div class="header-left">
        <div class="sys-logo">
          {
            this.$slots.logo ? this.$slots.logo : <img src={webSiteLogo} alt="" />
          }
        </div>
        <div class="btn-refresh" onClick={ this.refreshPage }></div>
      </div>
      { this.userInfo && this.renderRight() }
      <div class="search-box">
        <el-input
          placeholder="搜索应用, 回车确认搜索"
          v-model={this.kw}
          clearable
          onChange={this.searchBoxChanged}
          ref="refSearch"
          onClear={this.doSearch}>
          <el-button slot="prepend" icon="el-icon-search" onClick={this.doSearch}></el-button>
        </el-input>
      </div>
    </div>
  }
}
